import { useNavigate } from 'react-router';

type To = string | { search: string };
type RouterHistory = {
	goBack: () => void;
	push: (to: To) => void;
	replace: (to: To) => void;
};

export function useRouterHistory(): RouterHistory {
	const navigate = useNavigate();
	return {
		goBack: () => navigate(-1),
		push: (to) => navigate(to),
		replace: (to) => navigate(to, { replace: true })
	};
}
